import React, {FC} from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import {OptionsProp} from '../../../../constants/types';

export interface SelectProps {
  name: string,
  id?: string,
  value: string,
  label?: string,
  size?: 'medium' | 'small',
  options: OptionsProp[],
  onChange: (value) => void,
  error?: string,
  touched?: boolean,
  disabled?: boolean,
  required?: boolean,
  autoWidth?: boolean,
  onFocus?: () => void,
  onBlur?: () => void,
  apiValidationError?: Nullable<Dictionary<string[]>>,
  disableClearable?: boolean,
  disableCloseOnSelect?: boolean,
}

const Select: FC<SelectProps> = ({
  name,
  id,
  value,
  label,
  options,
  onChange,
  error,
  touched,
  onFocus,
  onBlur,
  apiValidationError,
  size = 'medium',
  disabled = false,
  autoWidth = false
}) => {
  const hasErrors = !!apiValidationError || !!(touched && error);
  const errorMessage = apiValidationError?.[name] || (touched && error);

  return (
    <TextField
      name={name}
      id={id}
      select
      label={label}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value || []}
      onChange={onChange}
      error={hasErrors}
      helperText={errorMessage}
      size={size}
      disabled={disabled}
      SelectProps={{
        autoWidth
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default Select;
